import { request } from 'Lib/axios'

type ZendeskLoginResponse = {
  data: {
    jwt: string
    jwt_req_url: string
    return_to: string
  }
}

export const getZendeskLinkAndToken = (userId: number) =>
  request<ZendeskLoginResponse>({
    url: `/users/${userId}/customer-support/help-center-auth`,
    method: 'GET',
  })

const redirectToZendeskHelpCenter = (
  zendeskTokenResponse: ZendeskLoginResponse,
  redirectUrl: string
) =>
  request<ZendeskLoginResponse>({
    baseURL: zendeskTokenResponse.data.jwt_req_url,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: {
      jwt: zendeskTokenResponse.data.jwt,
      return_to: redirectUrl,
    },
  })

const REDIRECT_PARAM = 'return_to'

export const useRedirectToZendeskHelpCenter = (userId: number, hcArticle: string) => {
  return getZendeskLinkAndToken(userId)
    .then((response) => {
      if (!(response instanceof Error) && response?.data) {
        const url = new URL(response.data.return_to)
        if (hcArticle && url.searchParams.has(REDIRECT_PARAM))
          url.searchParams.set(REDIRECT_PARAM, hcArticle)

        redirectToZendeskHelpCenter(response, url.toString())
          .then()
          .catch((err) => console.error(err))
      }
    })
    .catch((err: Error) => console.error(err))
}
